<template>
  <b-modal
    id="create_purchase_score"
    hide-footer
    title="افزودن امتیاز خرید جدید"
    size="lg"
  >
    <form 
    autocomplete="off"
    @submit.prevent="createPurchaseScore">
      <b-form-group>
        <div class="d-flex justify-content-between">
          <label> عنوان : </label>
        </div>
        <b-form-input v-model="form.title" type="text"></b-form-input>
      </b-form-group>
      <b-form-group>
        <div class="d-flex justify-content-between">
          <label> حداقل مبلغ خرید : </label>
        </div>
        <b-form-input v-model="form.min_value" type="number"></b-form-input>
      </b-form-group>
      <b-form-group>
        <div class="d-flex justify-content-between">
          <label> حداکثر مبلغ خرید : </label>
        </div>
        <b-form-input v-model="form.max_value" type="number"></b-form-input>
      </b-form-group>
      <b-form-group>
        <div class="d-flex justify-content-between">
          <label> مقدار بن : </label>
        </div>
        <b-form-input v-model="form.bon_value" type="number"></b-form-input>
      </b-form-group>
      <b-form-group>
        <div class="d-flex justify-content-between">
          <label> مقدار امتیاز : </label>
        </div>
        <b-form-input v-model="form.score_value" type="number"></b-form-input>
      </b-form-group>

      <div class="text-center mt-3">
        <button :disabled="disabled" class="btn btn-success">ثبت</button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import CreatePurchaseScoreImpl from "@@/core/components/customerClub/purchaseScore/CreatePurchaseScoreImpl.js";
export default {
  extends: CreatePurchaseScoreImpl,
};
</script>